export const events = {
  requestUpsell: 'Request module upsell',
  openModalWithUpsellInfo: 'Open modal with upsell information',
  viewUpgradeLegacyPage: 'View upgrade legacy page',
  upsellMeetingBooked: 'Upsell meeting booked',
  openUpsellBookingCalendar: 'Open upsell booking calendar',
  openRequestUpgradeModal: 'Open request upgrade modal',
  seeUpsellTrialBanner: 'See upsell trial banner with remaining days',
  viewDiscoverabilityWidget: 'View discoverability widget',
  clickedDiscoverabilityWidget: 'Clicked discoverability widget',
  upsellDemoButtonClicked: 'Demo button clicked',
  upsellTrialButtonClicked: 'Trial button clicked',
  seeSharedSessionOption: 'See shared session option',
  clickSharedSessionLink: 'Click on shared session link',
  viewProductUpsellComponent: 'View product upsell component',
  dismissProductUpsellComponent: 'Dismiss product upsell component',
  clickProductUpsellComponent: 'Click product upsell component',
  viewSelfUpsellModal: 'View self upsell modal',
  closeSelfUpsellModal: 'Close self upsell modal',
  clickReviewOrderButton: 'Click review order button',
  clickConfirmPaymentButton: 'Click confirm payment button',
  clickRequestAssistanceButton: 'Click request assistance button',
  viewSelfUpsellSuccessStep: 'View self upsell success step',
  viewSelfUpsellErrorStep: 'View self upsell error step',
  openSetupGuide: 'Open setup guide',
  viewHelloOneMotion: 'View hello one motion',
  viewOneBetaMotion: 'View one beta motion',
  closeHelloOneMotion: 'Close hello one motion',
  viewOneWaitlistButton: 'View one waitlist button',
  viewOneLandingLink: 'View one landing link',
  clickOneWaitlistButton: 'Click one waitlist button',
  clickOneLandingLink: 'Click one landing link',
  joinedOneWaitlist: 'Joined one waitlist',
  viewOneLandingPage: 'View one landing page',
  viewOnePromoPage: 'View one promo page',
  clickModuleCard: 'Click module card',
  clickViewAllModulesButton: 'Click view all modules button',
  submitSelfUpsellDissmisReason: 'Submit self upsell dismiss reason',
  skipSelfUpsellDissmisReason: 'Skip self upsell dismiss reason',
  viewOneSidepanel: 'View One sidepanel',
  closeOneSidepanel: 'Close One sidepanel',
  clickSkipWaitlistButton: 'Click skip waitlist button',
  clickHowButtonPromoSection: 'Click how button promo section',
  clickExploreMore: 'Click explore more button',
  closeBookAMeeting: 'Close book a meeting',
  bookAMeeting: 'Book a meeting',
  openBookAMeeting: 'Open book a meeting',
  viewBookAMeetingExitModal: 'View Book a meeting exit modal',
}
